var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{key:_vm.key})],1):_c('router-view',{key:_vm.key})}
var staticRenderFns = []

export { render, staticRenderFns }